module.exports = __webpack_public_path__ + "static/img/7.7918de2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/2/sp/7.png
// module id = u87b
// module chunks = 0